import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class CommonService {
  myAppUrl: any;
  public headers!: Headers;
  public _fetchOktaConfig: string = "Home/GetOktaConfigDetails";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  httpGet(param: string, urlloc: any): Observable<any> {
    return this._http.get(urlloc, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    }).pipe(map(res => res))
      .pipe(catchError(this.handleError));
  }

  httpPostWOHeader(urlloc: any, formBody: any, param: any): Observable<any> {
    return this._http.post(urlloc, formBody, param)
      .pipe(map(res => res))
      .pipe(catchError(this.handleError));
  }

  httpPost(param: any, urlloc: any, headers: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };
    return this._http.post(urlloc, param, httpOptions)
      .pipe(map(res => res))
      .pipe(catchError(this.handleError));
  }

  GetOktaConfigDetails() {
    this._http.get<any>(this.myAppUrl + this._fetchOktaConfig).subscribe(response => {
      const ISSUER = 'https://isg-one.okta.com/oauth2/aus1olhcshbvy7Th7357';
      const CLIENT_ID = "0oa1ol6mozivVhsgc357";
      const CALLBACK_PATH = window.location.origin + '/implicit/callback';
      const REDIRECT_URI = CALLBACK_PATH;

      const config = {
        issuer: ISSUER,
        clientId: CLIENT_ID,
        redirectUri: REDIRECT_URI,
        scopes: ['openid'],
        flow: "Implicit",
      };

      return config;
    });
  }

  private handleError(error: any) {
    return throwError(() => error?.error || 'Opps!! Server error');
  }
}
